import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { ApiIntegration } from "../../_services/api.integration";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
@Component({
  selector: 'app-driver-my-account',
  templateUrl: './driver-my-account.component.html',
  styleUrls: ['./driver-my-account.component.css']
})
export class DriverMyAccountComponent implements OnInit {
  tabClicked: string = "profile";
  driverDetails: any = {
    driverName: "",
  };
  productImage: string;
  uploadImage: string;
  password: string;
  changePassword: string;
  reEnterPassword: string;
  statusText: string;
  imageUrl: string;
  errorMessage: string;
  successMessage: string;
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  currentPwdError: string = '';
  newPwdError: string = '';
  confirmPwdError: string = '';


  constructor(private alertService: AlertService, private g: Globals, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.g.page = "My Account";
    this.g.loaderDisplay = "display";
    this.api.getShiftDrivers(this.user.driverId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.driverDetails = data;
      this.imageUrl = this.driverDetails.driverLicense;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });

  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
  }
  ngOnInit() {
  }

  typeDriverName() {
    this.statusText = "";
    if (this.driverDetails.driverName == '' || this.driverDetails.driverName === null || this.driverDetails.driverName === undefined || this.driverDetails.driverName === 'undefined') {
      this.statusText = 'Please Enter Driver Name';
    }
  }
  submitDriver() {


    this.statusText = "";
    if (this.driverDetails.driverName == '' || this.driverDetails.driverName === null || this.driverDetails.driverName === undefined || this.driverDetails.driverName === 'undefined') {
      this.statusText = 'Please Enter Driver Name';
    }
    if (this.statusText != "") {
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateDrivers', {
      "driverName": this.driverDetails.driverName,
      "organizationId": 1,
      "id": this.user.driverId,
      "status": this.driverDetails.status,
      "mobileNumber": this.driverDetails.mobileNumber,
      "email": this.driverDetails.email,
      "driverLicense": this.imageUrl


    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";

        if (data['code'] == 200) {
          this.alertService.success('Profile', 'Updated Successfully');

          this.router.navigate(['/admin/driverMyAccount']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

          console.log(err);

        }
      )
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }
  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
  }

  submitImage() {
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
      });
  }
  typeConfirmPwd() {
    this.confirmPwdError = '';
    if (!this.confirmPassword) {
      this.confirmPwdError = 'Please enter confirm password';
    } else if (this.confirmPassword !== this.newPassword) {
      this.confirmPwdError = 'Password does not match';
    }
  }

  typeNewPwd() {
    this.newPwdError = '';
    if (!this.newPassword) {
      this.newPwdError = 'Please enter new password';
    } else if (this.newPassword.length <= 5) {
      this.newPwdError = 'Password must be minimum 6 characters';
    }
  }

  typeCurrentPwd() {
    this.currentPwdError = '';
    if (!this.currentPassword) {
      this.currentPwdError = 'Please enter current password';
    }
  }

  editAccountOwner() {
    this.typeNewPwd();
    this.typeCurrentPwd();
    this.typeConfirmPwd();
    if (this.confirmPwdError != "" || this.newPwdError != "" || this.currentPwdError != "") {
      return false;

    }
  }
}
